import { Navbar } from "../components/layout/Navbar";
import { Footer } from "../components/layout/Footer";
import { Target, Eye, Lightbulb, Users, TrendingUp, Globe } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";

const values = [
  {
    icon: Lightbulb,
    title: "الابتكار",
    description: "نؤمن بقوة الأفكار الجديدة وقدرتها على تغيير المستقبل",
  },
  {
    icon: Users,
    title: "الشراكة",
    description: "نبني علاقات طويلة الأمد قائمة على الثقة والمنفعة المتبادلة",
  },
  {
    icon: TrendingUp,
    title: "النمو المستدام",
    description: "نسعى لتحقيق عوائد مستدامة تخدم جميع الأطراف",
  },
  {
    icon: Globe,
    title: "الأثر",
    description: "نهدف لخلق أثر إيجابي في اقتصاد المعرفة العربي",
  },
];

const About = () => {
  const { t, language } = useLanguage();

  // Translated values data
  const translatedValues = [
    {
      icon: Lightbulb,
      title: t('about.values.innovation.title'),
      description: t('about.values.innovation.description'),
    },
    {
      icon: Users,
      title: t('about.values.partnership.title'),
      description: t('about.values.partnership.description'),
    },
    {
      icon: TrendingUp,
      title: t('about.values.sustainability.title'),
      description: t('about.values.sustainability.description'),
    },
    {
      icon: Globe,
      title: t('about.values.impact.title'),
      description: t('about.values.impact.description'),
    },
  ];

  return (
    <div className="min-h-screen" dir={language === "ar" ? "rtl" : "ltr"}>
      <Navbar />
      <main>
        {/* Hero */}
        <section className="py-20 bg-muted/30">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto text-center">
              <span className="text-sm font-semibold text-primary uppercase tracking-wide">
                {t('about.hero.subtitle')}
              </span>
              <h1 className="text-4xl md:text-5xl font-bold mt-3 mb-6">
                {t('about.hero.title')}
              </h1>
              <p className="text-lg text-muted-foreground leading-relaxed">
                {t('about.hero.description')}
              </p>
            </div>
          </div>
        </section>

        {/* Mission & Vision */}
        <section className="py-20">
          <div className="container mx-auto px-4">
            <div className="grid md:grid-cols-2 gap-12">
              <div className="bg-card rounded-3xl p-8 md:p-12 shadow-card">
                <div className="w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center mb-6">
                  <Target className="w-8 h-8 text-primary" />
                </div>
                <h2 className="text-2xl font-bold mb-4">{t('about.mission.title')}</h2>
                <p className="text-muted-foreground leading-relaxed">
                  {t('about.mission.description')}
                </p>
              </div>
              <div className="bg-card rounded-3xl p-8 md:p-12 shadow-card">
                <div className="w-16 h-16 rounded-2xl bg-secondary/10 flex items-center justify-center mb-6">
                  <Eye className="w-8 h-8 text-secondary" />
                </div>
                <h2 className="text-2xl font-bold mb-4">{t('about.vision.title')}</h2>
                <p className="text-muted-foreground leading-relaxed">
                  {t('about.vision.description')}
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Values */}
        <section className="py-20 bg-sidebar text-sidebar-foreground">
          <div className="container mx-auto px-4">
            <div className="text-center max-w-2xl mx-auto mb-16">
              <h2 className="text-3xl md:text-4xl font-bold mb-4">{t('about.values.title')}</h2>
              <p className="text-sidebar-foreground/70">
                {t('about.values.subtitle')}
              </p>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              {translatedValues.map((value) => (
                <div key={value.title} className="text-center">
                  <div className="w-16 h-16 rounded-2xl bg-sidebar-primary/20 flex items-center justify-center mx-auto mb-6">
                    <value.icon className="w-8 h-8 text-sidebar-primary" />
                  </div>
                  <h3 className="text-xl font-bold mb-3">{value.title}</h3>
                  <p className="text-sidebar-foreground/70">{value.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="py-20">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
              {[
                { number: "100+", label: t('about.stats.projectsFunded') },
                { number: "50M+", label: t('about.stats.investments') },
                { number: "50+", label: t('about.stats.activeInvestors') },
                { number: "92%", label: t('about.stats.successRate') },
              ].map((stat) => (
                <div key={stat.label} className="text-center">
                  <span className="text-4xl md:text-5xl font-bold text-gradient">{stat.number}</span>
                  <p className="text-muted-foreground mt-2">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default About;